import styled, { keyframes } from 'styled-components';

import BlackFridayBgMobile from '../../../assets/black-friday-bg.mobile.png';
import { forMd } from '../../../config/_variables';

const BannerAnimattion = keyframes`
  0% {
    transform: translateY(-100%);
  }

  100% {
    transform: translateY(0px);
  }
`;

const MenuAnimation = keyframes`
  0% {
    transform: translateY(-200px);
  }

  100% {
    transform: translateY(0px);
  }
`;

export const BannerWrapper = styled.div`
  align-items: center;
  animation-direction: normal;
  animation-duration: 0.9s;
  animation-fill-mode: forwards;
  animation-name: ${BannerAnimattion};
  background-color: #000;
  background-image: url(${BlackFridayBgMobile});
  background-position: top;
  background-repeat: repeat-x;
  background-size: 150px 85%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 351px;
  justify-content: flex-start;
  margin-bottom: unset;
  overflow: hidden;
  padding: 0;
  padding-top: 32px;
  width: 100%;

  ${forMd} {
    background-image: none;
    flex-direction: row;
    gap: 50px;
    height: 160px;
    justify-content: center;
    margin-bottom: 24px;
    padding-top: unset;
    width: 948px;
  }

  &:not(.d-none) ~ .menu:not(.show):not(.hidden),
  &:not(.d-none) ~ header + section,
  &:not(.d-none) ~ header + div {
    animation-direction: normal;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-name: ${MenuAnimation};
    top: auto;
  }

  &.hide {
    display: none;
    height: 0;
    visibility: hidden;
    width: 0;
  }
`;

export const BannerImage = styled.img`
  width: 224px;

  ${forMd} {
    margin: 0;
    width: 151px;
  }
`;

export const ContainerTexts = styled.div`
  align-items: flex-start;
  display: none;
  flex-direction: column;
  max-width: 198px;

  ${forMd} {
    display: flex;
  }

  p {
    font-family: 'Poppins', sans-serif;
    font-size: 28px;
    line-height: 1;
    text-align: start;
    white-space: nowrap;

    img {
      margin-right: 0;
    }
    
    &:first-of-type {
      color: #fff;
      font-weight: 700;
    }

    &:nth-of-type(2) {
      color: #F8AB00;
      font-weight: 500;
    }

    &:last-of-type {
      color: #919191;
      font-size: 10px;
      font-weight: 400;
      line-height: 16px;
      margin-top: 13px;

      span {
        color: #F8AB00;
      }
    }
  }
`;

export const ContainerTextsMobile = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;

  ${forMd} {
    display: none;
  }

  p {
    font-family: 'Poppins', sans-serif;
    line-height: 1;
    text-align: center;
    
    &:first-of-type {
      color: #fff;
      font-size: 16px;
      font-weight: 700;

      span {
        font-weight: 800;
      }
    }

    &:last-of-type {
      bottom: 16px;
      color: #919191;
      font-size: 10px;
      font-weight: 400;
      line-height: 16px;
      position: absolute;

      span {
        color: #F8AB00;
      }
    }
  }
`;

export const Separator = styled.div`
  background-color: #F16526;
  border-radius: 2px;
  display: none;
  height: 64px;
  width: 1.5px;

  ${forMd} {
    display: block;
  }
`;

export const BackgroundContainer = styled.div`
  display: none;
  gap: 7px;
  left: ${(props) => props.left};
  opacity: 0.4;
  position: absolute;
  right: ${(props) => props.right};
  z-index: -1;

  ${forMd} {
    display: flex;
  }
`;
